import IconCaretButtonLeft from "@/components/icons/IconCaretButtonLeft";
import IconCaretButtonRight from "@/components/icons/IconCaretButtonRight";
import cn from "@/lib/cn";
import fireElementClicked from "@/lib/tagular/fire-element-clicked";
import { TAGULAR_ELEMENT } from "@/types/tagular";
import React from "react";

interface NavigationProps {
  onPrevious: () => void;
  onNext: () => void;
  isPreviousDisabled?: boolean;
  isNextDisabled?: boolean;
  className?: string;
  tagularProps?: TAGULAR_ELEMENT;
  elementName?: string;
}

const Navigation: React.FC<NavigationProps> = ({
  onPrevious,
  onNext,
  isPreviousDisabled = false,
  isNextDisabled = false,
  className,
  tagularProps,
  elementName,
}) => {
  const baseButtonClasses = `
    absolute
    flex items-center justify-center
    rounded-full
    bg-neutral-light
    border-2 border-transparent
    transition-all duration-200
    cursor-pointer
    hover:bg-white
    disabled:opacity-30
    disabled:cursor-not-allowed
  `
    .trim()
    .replace(/\s+/g, " ");

  const livePositioningClasses = `
    z-20
    shadow-slider-navigation
  `
    .trim()
    .replace(/\s+/g, " ");
  const buttonSizeClasses = "w-10 h-10 md:w-10 md:h-10 lg:w-14 lg:h-14";

  const caretSizeClasses = "w-6 h-6 md:w-8 md:h-8";

  const previousPositionClass = "top-1/2 -translate-y-1/2 -left-[3%]";

  const nextPositionClass = "top-1/2 -translate-y-1/2 -right-[3%]";

  return (
    <>
      <button
        className={cn(
          baseButtonClasses,
          livePositioningClasses,
          buttonSizeClasses,
          previousPositionClass,
          className
        )}
        onClick={() => {
          fireElementClicked({
            actionOutcome: "carouselLeft",
            elementType: "iconButton",
            text: "previous",
            position: 1,
            name: elementName
              ? `iconButtonProductCards${elementName}CarouselLeft`
              : `iconButton${tagularProps?.location}CarouselLeft`,
            ...tagularProps,
          });
          onPrevious();
        }}
        disabled={isPreviousDisabled}
        aria-label="Previous"
      >
        <IconCaretButtonLeft
          theme="purple"
          style="filled"
          className={cn(caretSizeClasses)}
        />
      </button>

      <button
        className={cn(
          baseButtonClasses,
          livePositioningClasses,
          buttonSizeClasses,
          nextPositionClass,
          className
        )}
        onClick={() => {
          onNext();
          fireElementClicked({
            actionOutcome: "carouselRight",
            elementType: "iconButton",
            text: "next",
            position: 2,
            name: elementName
              ? `iconButtonProductCards${elementName}CarouselRight`
              : `iconButton${tagularProps?.location}CarouselRight`,
            ...tagularProps,
          });
        }}
        disabled={isNextDisabled}
        aria-label="Next"
      >
        <IconCaretButtonRight
          theme="purple"
          style="filled"
          className={cn(caretSizeClasses)}
        />
      </button>
    </>
  );
};

export default Navigation;
